import Flickity from 'flickity-fullscreen';

const PER_PAGE = 3;

export default class {
    constructor(selector) {
        this.$carousel = $(selector);
        this.$viewport = null;
        this.$cards = this.$carousel.find(".card");
        this.pages = 0;

        if (!this.$carousel.length)
            return;

        this.carousel = new Flickity(this.$carousel.get(0), {
            groupCells: true,
            pageDots: this.$cards.length > PER_PAGE,
            contain: true,
            cellAlign: "left",
            selectedAttraction: 0.2,
            friction: 0.8,
            on: {
                ready: () => this.ready(),
                change: index => this.change(index)
            }
        });
    }

    ready() {
        this.$viewport = this.$carousel.find(".flickity-viewport");
        this.pages = Math.floor((this.$cards.length + PER_PAGE - 1) / PER_PAGE);

        this.$viewport.addClass("gradient-right");
    }

    change(index) {
        switch(true) {
            case index === 0:
                this.$viewport.removeClass("gradient-left").addClass("gradient-right");
                break;

            case index === this.pages - 1:
                this.$viewport.removeClass("gradient-right").addClass("gradient-left");
                break;

            default:
                this.$viewport.removeClass("gradient-left gradient-right");
        }
    }
}
